import { Component, HostBinding, Input, OnChanges, inject } from '@angular/core';
import { SjoborgTrackingLinkService } from '../../services/sjoborg-tracking-link.service';

interface SjoborgTrackingLink {
  url: string;
  packageNumber: string;
}

@Component({
    selector: 'sjoborg-tracking-links',
    templateUrl: './sjoborg-tracking-links.component.html',
    standalone: false
})
export class SjoborgTrackingLinksComponent implements OnChanges {
  @Input() packageNumbers: string[];
  @Input() packageLevs: string[];

  protected trackingLinkService = inject(SjoborgTrackingLinkService);

  links: SjoborgTrackingLink[] = [];

  // stays inline next to the order number for a single package, breaks to its own line when stacked
  @HostBinding('class.d-block')
  get stacked(): boolean {
    return this.links.length > 1;
  }

  ngOnChanges(): void {
    const packageLev = this.packageLevs?.[0];
    this.links = (this.packageNumbers || [])
      .map(packageNumber => ({
        packageNumber,
        url: this.trackingLinkService.getTrackingLink(packageLev, packageNumber)
      }))
      .filter((link): link is SjoborgTrackingLink => !!link.url);
  }
}
